import React from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { IAssortmentMatch } from '../../../../../Interface/ListingRequest';
import MatchConfirmation from './MatchConfirmation/MatchConfirmation';
// @ts-ignore
import styles from './AssortmentMatchHint.module.scss?module';

type AssortmentMatchHintProps = {
  matches: IAssortmentMatch[];
  exact: boolean;
  confirmed: boolean;
  onConfirmedChange: (confirmed: boolean) => void;
  onNavigate: () => void;
};

const AssortmentMatchHint = ({
  matches,
  exact,
  confirmed,
  onConfirmedChange,
  onNavigate,
}: AssortmentMatchHintProps) => {
  if (0 === matches.length) {
    return null;
  }

  return (
    <div className={clsx(styles.hint, exact ? styles.exact : '')}>
      <span>
        {exact
          ? 'We already carry this, no request needed:'
          : 'Already in our assortment:'}
      </span>{' '}
      {matches.map((match, index) => (
        <React.Fragment key={`${match.type}-${match.url}`}>
          {index > 0 && ', '}
          <Link to={match.url} onClick={onNavigate}>
            {'product' === match.type
              ? `${match.brand_name} ${match.name}`
              : match.name}
          </Link>
        </React.Fragment>
      ))}
      {/* An exact match blocks the request outright, so there is nothing left
          to confirm - the customer cannot send it either way. */}
      {!exact && (
        <MatchConfirmation
          confirmed={confirmed}
          onConfirmedChange={onConfirmedChange}
        />
      )}
    </div>
  );
};

export default AssortmentMatchHint;
